export default {
  home: '商户首页',
  introduce: '平台介绍',
  policy: '招商政策',
  switchLang: '多语言',
  openMerchants: '成为卖家',
  login: '登录',
  sellerCenter: '商户后台',
  logOut: '退出',
  loginError: '未检查到店铺信息,请退出重新登录',
  noStore: '未检查到店铺信息',
  app: '卖家APP',
  helpCenter: '注册指南'
}
